export const DEFAULT_TRANSITION_DURATION = 1.5;

export const DEFAULT_CAROUSEL_ITEM_DURATION_S = 15;
